export const locale = {
    lang: 'en',
    data: {
        'PROJECTS': {
            'PROJECTS': 'Projects'
        }
    }
};
